const getEcommLinkWithWalletData = function () {
  let href = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let ecommercePaymentsInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let userZip = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  let baseUrl = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  let dealerId = arguments.length > 4 ? arguments[4] : undefined;
  const queryParams = {
    ...ecommercePaymentsInfo,
    mw_z: userZip
  };
  const dealerIdKey = 'dealerId';
  if (baseUrl) {
    queryParams.url = encodeURI(baseUrl);
  }
  try {
    const url = new URL(href);
    Object.entries(queryParams).forEach(_ref => {
      let [key, value] = _ref;
      return value != null && url.searchParams.append(key, value);
    });
    if (dealerId && !url.searchParams.has(dealerIdKey)) url.searchParams.append(dealerIdKey, dealerId);
    if (url.hash) url.hash += (url.hash.includes('?') ? '&' : '?') + url.searchParams.toString();
    return url.toString();
  } catch {
    return href;
  }
};
export { getEcommLinkWithWalletData as default };
